<template>
  <div>
    <main>
      <section class="absolute w-full h-full">
        <div class="absolute top-0 w-full h-full bg-white"
          style="background: linear-gradient(135deg, #CCD7CC, #E896A3, #A9C0EB, #5D7EB2)"></div>
        <div class="container mx-auto px-4 h-full">
          <div class="flex content-center items-center justify-center h-full">
            <div class="w-full lg:w-8/12 px-4">
              <div
                class="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-white border-0">
                <div class="flex-auto p-8">
                  <div>
                    <a href="/login" class="text-gray-600 text-sm font-medium opacity-50">
                      <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                        viewBox="0 0 24 24" class="w-4 h-4 inline fill-current ">
                        <path
                          d="M19 11H7.83l4.88-4.88c.39-.39.39-1.03 0-1.42a.996.996 0 0 0-1.41 0l-6.59 6.59a.996.996 0 0 0 0 1.41l6.59 6.59a.996.996 0 1 0 1.41-1.41L7.83 13H19c.55 0 1-.45 1-1s-.45-1-1-1z"
                          fill="currentColor"></path>
                      </svg> Back</a>
                  </div>
                  <h3 class="text-gray-600 text-2xl font-medium my-2">
                    Verify Your Account
                  </h3>
                  <span class="text-sm font-thin">We are sending a verification code to your phone</span>
                  <form @submit.prevent class="mt-8">
                    <div class="relative w-full mb-3">
                      <label class="block  text-gray-700 text-xs font-medium mb-2" for="grid-password">
                        Verification code:
                      </label>
                      <Input id="verify" type="text" class="text-2xl" v-model="code"
                        style="transition: all 0.15s ease 0s;" autofocus inputmode="numeric" pattern="[0-9]*"
                        @keydown.enter="verify" name="verify" autocomplete="off" data-1p-ignore />
                    </div>
                    <div class="text-center mt-6">
                      <ul class="list text-red-500">
                        <li v-for="err in errors" :key="err">{{ err }}</li>
                      </ul>
                    </div>
                    <div class="text-center mt-6">
                      <Button class=" text-white w-full" type="button" name="submit"
                        style="transition: all 0.15s ease 0s;" @click="verify()">
                        Verify
                      </Button>
                      <div v-if="errors.length" class="text-center mt-4 text-gray-500">
                        <small>Or&nbsp;</small>
                        <RouterLink to="/login" class="underline">
                          <small>go back to login</small>
                        </RouterLink>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>

  </div>
</template>

<script setup lang="ts">
  import { ref, onMounted, onActivated } from 'vue'
  import { useRouter } from 'vue-router'
  import type { ErrorDetail, ErrorModel } from '@/models/error'
  import { isErrorModel } from '@/models/error'
  import { useAuthStore } from '@/stores/auth'
  import { Button } from '@/components/ui/button'
  import { Input } from '@/components/ui/input'

  const router = useRouter()
  const authStore = useAuthStore()

  const phone = ref<string>(router.currentRoute.value.query.phone as string)
  const code = ref<string>("")
  const errors = ref<string[]>([])

  const verify = async () => {
    errors.value = []
    if (!phone.value) {
      router.push('/login')
      return
    }
    if (!code.value) {
      errors.value = ["Please enter a valid code or try logging in again"]
      return
    }
    try {
      await authStore.verify(phone.value, code.value)
    } catch (err: any) {
      if (isErrorModel(err.body)) {
        const e = err.body as ErrorModel
        if (e.title) errors.value.push(e.title)
        if (e.detail) errors.value.push(e.detail)
        e.errors?.forEach((errDetail: ErrorDetail) => {
          errors.value.push(errDetail.message)
        })
      } else if (err?.message) {
        errors.value.push(err.message)
      } else {
        errors.value.push('An error occurred')
      }
    }
  }

  onMounted(() => {
    document.getElementById('verify')!.focus()
  })
  onActivated(() => {
    document.getElementById('verify')!.focus()
  })

</script>